<template>
  <div class="quizButton w-full" :click="quizButtonAction">
    <button class="transition duration-200 ease-in-out transform active:scale-95 rounded overflow-hidden w-full shadow-white" ontouchstart="" @click="quizButtonAction">
      <div class="bg-cover bg-center w-full h-24 md:h-32 lg:h-40" :style="{ 'background-image': 'url(' + getButtonImage() + ')' }"></div>
      <div class="p-2 md:p-4 bg-button">
        <p class="text-base font-medium text-gray-100">{{ buttonText }}</p>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'QuizButton',
  props: {
    id: Number,
    buttonImage: String,
    buttonText: String
  },
  methods: {
    quizButtonAction: function() {
      this.$emit('button-message', this.id);
    },
    getButtonImage() {
      return require('../assets/images/' + this.buttonImage);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
